import React from "react";
import { APICall } from "../../api_helper";
import { ListPageCreationProps } from "./NewPageComponent";
import { useQueryWrapper } from "../../helper";
import { NewNewModalWithFormComponent } from "../new_modal/NewNewModalWithFormComponent";
import {
  ListPageFilterComponent,
  ListPageFilterComponentProps,
} from "./ListPageFilterComponent";

export const NewParentChildListPageComponent = (props: {
  props: NewParentChildListPageComponentProps;
}) => {
  const [actualItems, setActualItems] = React.useState<any[]>([]);
  const [reloadKey, setReloadKey] = React.useState(0);
  const [filterData, setFilterData] = React.useState<any>(
    props.props.filterComponentProps?.startingData ?? {},
  );

  const doesParentIdExistInArray = (parentElementId: number, data: any) => {
    for (const element of data) {
      if (parentElementId === element.id) {
        return true;
      }
    }
    return false;
  };

  const getParentElements = (data: any) => {
    const parentElements = [] as any[];
    for (const element of data) {
      if (element[props.props.parentItem] === null) {
        parentElements.push(element);
      } else if (
        !doesParentIdExistInArray(element[props.props.parentItem].id, data)
      ) {
        parentElements.push(element);
      }
    }
    return parentElements;
  };

  const buildItems = (data: any) => {
    console.log("Building items from data: " + JSON.stringify(data));
    const parentElements = getParentElements(data);
    console.log("Parent elements: " + JSON.stringify(parentElements));
    const finalElements = [] as any[];
    for (const parentElement of parentElements) {
      finalElements.push(buildItem(parentElement, data));
    }
    setActualItems(finalElements);
  };

  const buildItem = (element: any, data: any[]): any => {
    const childrenElements = [] as any[];
    for (const potentialChildElement of data) {
      if (
        potentialChildElement[props.props.parentItem] &&
        potentialChildElement[props.props.parentItem].id === element.id
      ) {
        childrenElements.push(buildItem(potentialChildElement, data));
      }
    }
    element.children = childrenElements;
    return element;
  };

  useQueryWrapper(
    props.props.query.documentNode,
    {
      ...props.props.queryVariables,
      __reloadKey: reloadKey,
      filter: filterData,
    },
    (data) => {
      console.log(
        "Query response: " + JSON.stringify(data[props.props.query.key]),
      );
      buildItems(data[props.props.query.key]);
    },
  );

  // debug: inspect items to see which entry is missing `.name`
  React.useEffect(() => {
    console.log("NewParentChildListPageComponent actualItems:", actualItems);
  }, [actualItems]);

  return (
    <>
      {props.props.creationProps && (
        <>
          <NewNewModalWithFormComponent
            props={{
              header: `Create ${props.props.itemName}`,
              triggerProps: {
                label: `Create ${props.props.itemName}`,
                type: "button",
              },
              formComponentProps: props.props.creationProps.formComponentProps,
              apiCall: props.props.creationProps.apiCall,
              callback: () => setReloadKey((prev) => prev + 1),
            }}
          />
        </>
      )}
      {props.props.filterComponentProps && (
        <ListPageFilterComponent
          props={props.props.filterComponentProps}
          data={filterData}
          setData={setFilterData}
        />
      )}
      <div className="card-list">
        {actualItems
          .filter((item) => item != null) // drop undefined/null
          .map((item) => (
            <props.props.card
              key={item.id ?? JSON.stringify(item)}
              data={item}
              setReloadKey={setReloadKey}
              pageData={actualItems}
              setPageData={setActualItems}
            />
          ))}
      </div>
    </>
  );
};

export type NewParentChildListPageComponentProps = {
  type: "parent_child_list";
  query: APICall;
  queryVariables: any;
  itemName: string;
  parentItem: string;
  creationProps?: ListPageCreationProps;
  filterComponentProps?: ListPageFilterComponentProps;
  // component should accept props directly
  card: (props: {
    data: any;
    setReloadKey: any;
    pageData: any;
    setPageData: any;
  }) => JSX.Element;
};
